<template>
  <div class="companyProcessListView-all-box">
    <card class="content-list-box">
      <!--      <div class="content-list-box">-->
      <div class="content-title">{{ $t('formData.companyProcessInformation') }}</div>

      <div class="content-list">
        <div v-for="(item, index) in tableList" :key="'table' + index" class="column-dom clearfix">
          <!--          <div class="hint-title-name">-->
          <!--            Company Name Company Name Company Name-->
          <!--          </div>-->
          <div class="title-info-box clearfix">
            <div class="title">{{ item.processName }}</div>
            <div class="text-btn">
              <!-- <el-button type="text">Approve</el-button> -->
              <!-- <el-button type="text" @click="openProcessDetailPage(item.id, item.companyId)">{{ $t('button.viewProcess') }}</el-button>
              <el-button v-if="!isViewOnly" type="text" @click="openProcessEditPage(item.id, item.companyId)">{{ $t('button.editProcess') }}</el-button> -->

              <cus-btn type="view" @click="openProcessDetailPage(item.id, item.companyId)" />
              <cus-btn type="edit" @click="openProcessEditPage(item.id, item.companyId)" v-if="!isViewOnly"/>
            </div>
          </div>

          <!-- <div class="block-list-box">
            <div class="block-box">
              <div class="icon">
                <i class="el-icon-first-aid-kit" />
              </div>
              <div class="block-content">
                <div class="title">{{ $t('formData.technicalArea') }}</div>
                <div v-for="(item1, index) in item.technicalAreaList" :key="'technical' + index" class="info">{{ item1 }}</div>
              </div>
            </div>

            <div class="block-box">
              <div class="icon">
                <i class="el-icon-first-aid-kit" />
              </div>
              <div class="block-content">
                <div class="title">{{ $t('formData.status') }}</div>
                <div class="info">{{ item.statusName }}</div>
              </div>
            </div>

            <div class="block-box">
              <div class="icon">
                <i class="el-icon-first-aid-kit" />
              </div>
              <div class="block-content">
                <div class="title">{{ $t('formData.createdBy') }}</div>
                <div class="info">{{ item.createName }}</div>
              </div>
            </div>

            <div class="block-box">
              <div class="icon">
                <i class="el-icon-first-aid-kit" />
              </div>
              <div class="block-content">
                <div class="title">{{ $t('formData.createdTime') }}</div>
                <div class="info">{{ item.createTime }}</div>
              </div>
            </div>
          </div> -->

          <stage-view :stageList="item.phases.filter(item=>{return item.status==0}).map((i)=>{return i.stageName})"></stage-view>
        </div>
      </div>

      <pagination-page
        :total="total"
        :change-fun="changeTablePage"
      />
    </card>
  </div>
</template>

<script>
import { companySelectProcess } from '../../api/companyManagement'
import { getTechnicalArea } from '../../utils/companyManagement'
export default {
  name: 'CompanyProcessListView',
  components: {},
  props: {
    isEdit: {// 是否编辑
      type: Boolean,
      default: false
    },
    isView: {// 是否查看
      type: Boolean,
      default: false
    },
    backToPage: {// 返回的页面
      type: String,
      default: 'companyListView'
    }
  },
  data() {
    return {
      total: 0,
      companyId: 0,
      pageNum: 1,
      pageSize: 10,
      technicalArea: '',
      tableList: [],
      isViewOnly: false//是否只查看
    }
  },
  computed: {
    lang() {
      return this.$store.state.app.language
    }
  },
  watch: {
    lang() {
      this.getSelectInfo()
    }
  },
  mounted() {
    if(this.isView || !this.buttonPerCheck("editProcess")){
      //查看状态或者没有列表页面编辑过程的权限
      this.isViewOnly = true
    } 
    const self = this
    window.companyProcessListView = self
    self.getSelectInfo()
    self.getCompanySelectProcess()
  },
  methods: {
    /**
    * 获取下拉框信息
    *  status 1 获取详情  0 不获取详情
    */
    getSelectInfo() {
      const self = this
      getTechnicalArea().then(response => {
        self.technicalArea = response.technicalArea
        self.getCompanySelectProcess()
      })
    },

    /**
    * 跳转到查看公司流程页面
    */
    openProcessDetailPage(id, companyId) {
      const backToPageId = this.$route.query.id
      const curRouteName = this.$route.name
      this.$router.push({
        name: 'companyProcessViewInList',
        query: {
          id: id,
          companyId: companyId,
          backToPage: curRouteName,
          backToPageId: backToPageId
        }
      })
    },

    /**
    * 跳转到编辑公司流程页面
    */
    openProcessEditPage(id, companyId) {
      const backToPageId = this.$route.query.id
      const curRouteName = this.$route.name
      this.$router.push({
        name: 'companyProcessEditInList',
        query: {
          id: id,
          companyId: companyId,
          backToPage: curRouteName,
          backToPageId: backToPageId
        }
      })
    },

    /**
    * tab 分页的 change 方法
    */
    changeTablePage(currentPage, pageSize) {
      const self = this
      self.pageNum = currentPage
      self.pageSize = pageSize
      self.getCompanySelectProcess()
    },

    /**
    * 获取流程列表
    */
    getCompanySelectProcess() {
      const self = this
      const id = this.$route.query.id
      companySelectProcess({ companyId: id, pageNum: self.pageNum, pageSize: self.pageSize, status: self.$route.query.status || '' }).then(response => {
        if (response.code === 200) {
          self.tableList = []
          self.total = response.data.total
          if (response.data.list && response.data.list.length) {
            response.data.list.forEach(item => {
              item.statusName = self.getStatus(item.status)

              // 技术领域 有没有值
              if (item.technicalArea && self.technicalArea.length) {
                item.technicalAreaList = []
                item.technicalArea = item.technicalArea.split(',')
                item.technicalArea.forEach(areaItem => {
                  const technicalArea = self.technicalArea.find(item1 => {
                    return item1.key === areaItem
                  })
                  item.technicalAreaList.push(technicalArea.value || '')
                })
              }
            })

            self.tableList = response.data.list
          }
        }
      })
    },

    /**
    * 获取 流程状态(1-待审批 2-通过 3-拒绝 4-草稿)
    */
    getStatus(status) {
      const self = this
      let name = ''
      switch (status) {
        case 1:
          name = self.$t('formData.pending')
          break
        case 2:
          name = self.$t('formData.through')
          break
        case 3:
          name = self.$t('formData.refusedTo')
          break
        case 4:
          name = self.$t('formData.theDraft')
          break
        default:
          return name
      }
      return name
    }
  }
}
</script>

<style scoped lang="scss">

</style>
